import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ContainerStyled = styled.div`
  display: grid;
  max-width: 1400px;
  padding: 0;
  width: 100%;
  animation: ${fadeIn} 0.3s ease-out;
  column-gap: 32px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: 300px 1fr;
    padding: 0 12px;
  }
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  grid-auto-rows: auto;
  grid-row-gap: 24px;
  justify-items: center;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const ContainerPointsStyled = styled.div`
  max-width: 800px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr); /* 12 columns, each taking equal width */
  gap: 12px; /* Gap between grid items */

  @media (min-width: 768px) {
    grid-template-columns: repeat(12, 1fr); /* Still 12 columns on desktop */
  }
`

export const ItemContainerStyled = styled.div`
  grid-column: span 12;
  
  @media (min-width: 768px) {
    grid-column: span 6;
  }

  width: 100%;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  background: ${({ theme }) => theme.bg2}
  border-radius: 16px;
  padding: 20px;

  h2 {
    margin-top: 12px;
    margin-bottom: 0;
  }
  span {
    font-size: 32px;
    font-weight: 600;
    color: #4afc38;
  }
  p {
    font-size: 10px;
    margin-bottom: 0;
  }
`

export const ItemContainer = styled.div``
